import { useState, useRef } from "react";
import { Product, SubProduct, ProductVersion } from "../utils/productFilterHelpers";

/**
 * Custom hook for managing product filter state
 */
export const useProductFilterState = (isAdmin: boolean) => {
    const [products, setProducts] = useState<Product[]>([]);
    const [productVersions, setProductVersions] = useState<ProductVersion[]>([]);
    const [subProducts, setSubProducts] = useState<SubProduct[]>([]);

    const [productIndexes, setProductIndexes] = useState<{ manual_key: string; faq_key: string }>({
        manual_key: isAdmin ? "0" : "",
        faq_key: isAdmin ? "0" : ""
    });

    const [productVersionIndexes, setProductVersionIndexes] = useState<{
        manual_version_key: string;
        faq_version_key: string;
    }>({
        manual_version_key: "0",
        faq_version_key: "0"
    });

    const [subProductIndexes, setSubProductIndexes] = useState<{
        manual_sub_key: string;
        faq_sub_key: string;
    }>({
        manual_sub_key: "0",
        faq_sub_key: "0"
    });

    const [productText, setProductText] = useState<string>("");
    const [productVersionText, setProductVersionText] = useState<string>("");
    const [subProductText, setSubProductText] = useState<string>("");

    const [isMainDropdownOpen, setIsMainDropdownOpen] = useState<boolean>(false);
    const [isVersionsOpen, setIsVersionsOpen] = useState<boolean>(false);
    const [isSubDropdownOpen, setIsSubDropdownOpen] = useState<boolean>(false);
    const [emptyProduct, setEmptyProduct] = useState<boolean>(false);

    const [isHovered, setIsHovered] = useState(-1);
    const [isSubHovered, setIsSubHovered] = useState(-1);
    const [isVersionsHovered, setIsVersionsHovered] = useState(-1);

    // Refs
    const mainDropdownRef = useRef<HTMLDivElement | null>(null);
    const divProdFilterRefs = useRef<(HTMLDivElement | null)[]>([]);
    const divProdVersionFilterRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [lastHoveredRef, setLastHoveredRef] = useState<any>(undefined);
    const [lastVerHoveredRef, setLastVerHoveredRef] = useState<any>(undefined);

    return {
        products,
        setProducts,
        productVersions,
        setProductVersions,
        subProducts,
        setSubProducts,
        productIndexes,
        setProductIndexes,
        productVersionIndexes,
        setProductVersionIndexes,
        subProductIndexes,
        setSubProductIndexes,
        productText,
        setProductText,
        productVersionText,
        setProductVersionText,
        subProductText,
        setSubProductText,
        isMainDropdownOpen,
        setIsMainDropdownOpen,
        isVersionsOpen,
        setIsVersionsOpen,
        isSubDropdownOpen,
        setIsSubDropdownOpen,
        emptyProduct,
        setEmptyProduct,
        isHovered,
        setIsHovered,
        isSubHovered,
        setIsSubHovered,
        isVersionsHovered,
        setIsVersionsHovered,
        mainDropdownRef,
        divProdFilterRefs,
        divProdVersionFilterRefs,
        lastHoveredRef,
        setLastHoveredRef,
        lastVerHoveredRef,
        setLastVerHoveredRef
    };
};
